import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { EnrollApi } from 'api';
import { SearchEnrollQueryType } from 'types';

function useGetAll(query: SearchEnrollQueryType, enabled = true) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => EnrollApi.getAll(query),
    {
      select: (data) => data.data,
      enabled,
    },
  );
}

export default useGetAll;
